import React, { Component } from "react";
import PatternPairs from "./PatternPairs";
import * as pageData from "./PageData";
const $ = window.$;

/* eslint-disable no-unused-vars */
const test = 1;
const completed = 2;
/* eslint-enable */

const pairsNeeded = 80;
var myVar = null;
var hits = 0;
var fails = 0;
var interval;

export default class SustainedAttention extends Component {
    constructor(props) {
        super(props);
        this.buttonClick = this.buttonClick.bind(this);
        this.interceptClick = this.interceptClick.bind(this);
        interval = this.props.devMode ? 500 : 1500;
        this.state = {
            innerStep: test,
            lastIndex: -1,
            pairIndex: 0
        };
    }

    componentDidMount() {
        this.afterUpdate();
        myVar = setInterval(this.setShape.bind(this), interval);
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    setShape() {
        try {
            let pairIndex = this.state.pairIndex;

            if (pairIndex < pairsNeeded - 1) {
                pairIndex++;
                this.setState({ pairIndex: pairIndex });
            } else {
                clearTimeout(myVar);
                myVar = null;
                this.setState({ innerStep: completed });
                this.props.clearDisableNext();
            }
        } catch (e) {
            clearTimeout(myVar);
            myVar = null;
        }
    }

    buttonClick(type) {
        if (type === "same") {
            if (this.state.lastIndex !== this.state.pairIndex) {
                const str1 = $(".pattern-01").html();
                const str2 = $(".pattern-02").html();

                if (str1 === str2) {
                    hits++;
                } else {
                    fails++;
                }

                this.setState({ lastIndex: this.state.pairIndex });
            }
        }
    }

    interceptClick(type) {
        if (type === "next") {
            this.props.next({ hits: hits, fails: fails });
            return true;
        }

        return false;
    }

    render() {
        const pairIndex = this.state.pairIndex;
        const checked = pairIndex === this.state.lastIndex ? "checked" : "";
        const time = pageData.secondsToTime(Math.floor((pairsNeeded - pairIndex) * (interval / 1000)));

        return (
<div className="test-page-content-inner test-page-sustained-attention">
    <div className="test-content">
        {renderTimer(time)}
        <div className="content-col-1">
            <PatternPairs pairsNeeded={pairsNeeded} pairIndex={pairIndex} checked={checked} />
        </div>
        <div className="content-col-2">
            {renderSameButton(this.props, this.state, this.buttonClick)}
        </div>
    </div>
</div>
        );
    }
}

function renderSameButton(props, state, buttonClick) {
    const disabled = (state.innerStep === completed || props.waitingForSpeech) ? "disabled" : "";
    return (
        <button className="btn btn-same" onClick={() => buttonClick("same")} disabled={disabled}>SAME</button>
    );
}

function renderTimer(time) {
    return (
        <div className="timer">
            <div className="timer-title">Time remaining:</div>
            <div className="timer-value">{time}</div>
        </div>
    );
}
